export const campaign = {
  field: {
    name: 'Title',
    status: 'Status',
    max_attempts: 'The maximum number of attempts',
    attempts_interval_min: 'Time between attempts (min.)',
    calls_limit: 'Number of simultaneous calls',
    caller_id: 'Caller number',
    pbx_number: 'Virtual PBX Number',
    progress: 'Progress',
    call_schedule: 'Call schedule',
    attempts: 'Attempts',
    dial_timeout: 'Maximum waiting time (sec.)',
    need_amd: 'Enable answering machine recognition'
  },

  deleted: 'deleted',

  tooltips: {
    dial_timeout: 'The maximum waiting time for the client to answer the call',
    need_amd: 'Answering Machine Detection - a model that allows you to recognize answering machines and silence'
  },

  table: {
    action: {
      show_detail_stat: 'View statistics',
      create: 'Add Campaign'
    }
  },

  filter: {
    status: {
      title: '@:autoinformer.campaign.field.status',
      active: 'Active',
      not_active: 'Inactive',
      all: 'All'
    },

    name: {
      title: '@:autoinformer.campaign.field.name'
    },

    pbx_number: {
      title: '@:autoinformer.campaign.field.pbx_number'
    },

    caller_id: {
      title: '@:autoinformer.campaign.field.caller_id'
    }
  },

  modal: {
    remove: {
      content: `Are you sure you want to delete the campaign <b>{name}<b>?`
    },

    change_status: {
      enable: 'Are you sure you want to start predictive dialer?',
      disable: 'Are you sure you want to stop predictive dialer?'
    },

    notice_pbx_module_required: {
      content:
        'To create predictive dialer campaigns, activate "<strong>the virtual PBX service</strong>"',
      ok: 'Connect'
    },

    create_scheme: {
      title: 'Create scheme',
      option1: 'Audio message',
      option2: 'IVR',
      option3: 'Own scheme'
    },

    delete_scheme: 'Are you sure you want to delete the existing schema?'
  },

  create: {
    title: '@:autoinformer.breadcrumb.campaign.new'
  },

  edit: {
    title: '@:autoinformer.breadcrumb.campaign.edit'
  },

  tasks: {
    title: 'Tasks'
  },

  form: {
    title: 'Basic information',
    title_schedule: 'Call schedule',
    recipients_title: 'Recipients',
    save_btn: 'Save',
    update_btn: 'Update',
    calling_scheme: 'Calling scheme',
    buttons: {
      create_scheme: 'Add scheme'
    }
  }
};
